/**
 * Example prompts for the demo — grouped so a presenter can walk the room
 * through the spec's headline flows. Wired into the suggestion rail and the
 * "Try a scenario" panel.
 */

export interface ScenarioGroup {
  id: string;
  label: string;
  icon: string; // material-symbols-rounded name
  prompts: string[];
}

export const SCENARIO_GROUPS: ScenarioGroup[] = [
  {
    id: 'reads',
    label: 'Reads & state',
    icon: 'search',
    prompts: [
      "What's out of stock on Delivery?",
      'Where is the Paneer Dosa visible?',
      'Is the Desserts category hidden anywhere?',
      'What session is the Mutton Mandi on?',
      'What are the breakfast hours?',
    ],
  },
  {
    id: 'diagnostics',
    label: 'Diagnostics',
    icon: 'help',
    prompts: [
      "Why isn't the Chicken Tikka showing on Delivery?",
      "Why isn't the Mutton Mandi showing right now?",
      "Why isn't Gulab Jamun on UberEats?",
    ],
  },
  {
    id: 'availability',
    label: '86 / Availability',
    icon: 'block',
    prompts: [
      '86 the Paneer Tikka till close',
      'Mark Chicken Biryani out of stock on Delivery until 9 PM',
      'Restore the Mango Lassi on Delivery',
      'Mark all Desserts OOS on Delivery',
    ],
  },
  {
    id: 'visibility',
    label: 'Visibility',
    icon: 'visibility_off',
    prompts: [
      'Hide the Kulfi on Delivery',
      'Hide the Desserts category on Dine-in',
      'Show the Chicken Tikka on Delivery',
    ],
  },
  {
    id: 'sessions',
    label: 'Sessions',
    icon: 'schedule',
    prompts: [
      'Make the Mutton Mandi a Friday-evening item',
      'Add the Veg Biryani to Lunch',
      'Make the Masala Dosa all day',
    ],
  },
  {
    id: 'combos',
    label: 'Multi-action & disambiguation',
    icon: 'tune',
    prompts: [
      '86 the Seekh Kebab on Delivery and hide the Desserts category on Dine-in',
      'Mark the dosa as unavailable',
      '86 the biryani on Delivery',
    ],
  },
  {
    id: 'scope',
    label: 'Out of scope',
    icon: 'gpp_maybe',
    prompts: [
      'Change the price of the Chicken Tikka',
      '86 the biryani at Anna Nagar',
      'Make Breakfast end at 11:30',
    ],
  },
];

/** Flattened catalogue (Control Centre) starter suggestions shown under the greeting. */
export const STARTER_PROMPTS: string[] = [
  "What's out of stock on Delivery?",
  "Why isn't the Chicken Tikka showing on Delivery?",
  '86 the Paneer Tikka till close',
  'Make the Mutton Mandi a Friday-evening item',
];

/** Reports examples — fallback when the live reports suggestions aren't available,
 * so a fresh chat always shows both reports AND Control Centre prompts. */
export const REPORTS_SAMPLE_PROMPTS: string[] = [
  'How are my sales today compared to yesterday?',
  'What were the top selling items last night?',
  'Which delivery provider brought in the most revenue?',
];

/**
 * Combined greeting for Brisque AI — states it serves BOTH reports questions and
 * Control Centre changes for the current outlet, and that changes are confirmed
 * on a card before anything updates (CCA-1.1).
 */
/** Short greeting kept in the thread (the rich empty-state hero shows the detail). */
export const GREETING_MESSAGE = "Hi, I'm Brisque AI. How can I help you today?";

/** One-line subtitle under the hero on the empty/intro screen. */
export const INTRO_SUBTITLE =
  "Ask about your reports, or tell me to update your menu. I'll always confirm before making any changes.";
